<script setup>
defineProps({
  result: {
    type: Array,
    required: true
  }
})
const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
</script>

<template>
  <div class="searchCandidate">
    <template
      v-for="(item) in result"
      :key="item.path"
    >
      <NuxtLink
        :to="`${isWebViewFlag ? `${runtimeConfig.app.baseURL}${item.path.replace(/^\//, '')}` : item.path}`"
        :external="isWebViewFlag"
        class="link"
      >
        <p class="city">
          {{ item.name }}
        </p>
        <p class="country">
          {{ item.pref }}
        </p>
      </NuxtLink>
    </template>
    <template v-if="result.length === 0">
      <p class="result">
        該当するゴルフ場が見つかりませんでした。
      </p>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.searchCandidate {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 400px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.25);
  z-index: 1;
  overflow-y: scroll;
  border-top: solid 1px #D8E0DF;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 100vmax;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: #438fec;
  }
  .link {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 5px 10px 5px 10px;
    cursor: pointer;
    border-bottom: solid 1px #D8E0DF;
  }
  .city {
    color: #3569c0;
    font-weight: 600;
    line-height: 17px;
  }
  .country {
    color: #303030;
    font-size: 13px;
    line-height: 15px;
  }
  .result {
    padding: 5px 20px 5px 10px;
  }
  @media (any-hover: hover) {
  }
}
@media screen and (min-width: 830px) {
  .searchCandidate {
    .link {
      padding-right: 25px;
      background-image: url('https://gvs.weathernews.jp/golf/image/common/icon_arrow_blue.svg');
      background-position: right 4px center;
      background-repeat: no-repeat;
      background-size: 12px;
    }
  }
}
</style>
